import React, { FC } from 'react';
import { Box } from '@mui/material';

type EventImageItemProps = {
    fileId: string;
    url: string;
};
const EventImageItem: FC<EventImageItemProps> = ({ url, fileId }: EventImageItemProps) => {
    return (
        <Box
            sx={{
                display: 'flex',
                bgcolor: '#222',
                borderRadius: 2,
                maxWidth: '150px',
                height: 90,
                alignItems: 'center',
                justifyContent: 'center',
            }}
        >
            <img
                alt={fileId}
                id={`img-${fileId}`}
                style={{
                    maxWidth: '150px',
                    height: 90,
                    objectFit: 'cover',
                    cursor: 'pointer',
                }}
                src={url}
                crossOrigin="anonymous"
            />
        </Box>
    );
};

export default EventImageItem;
